import { Component, OnInit, Inject } from '@angular/core';
import { ContaRef } from 'src/app/models/contaref';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ContaRefService } from 'src/app/services/conta-ref.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-conta-ref-modal',
  templateUrl: './conta-ref-modal.component.html',
  styleUrls: ['./conta-ref-modal.component.scss']
})
export class ContaRefModalComponent implements OnInit {
  contaRef: ContaRef;
  nomeBanco: string;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<ContaRefModalComponent>,
    private contaRefService: ContaRefService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
  ) {
  }

  ngOnInit(): void {
    this.buscarContaRef();
  }

  buscarContaRef() {
    this.carregandoService.mostra('buscarContaRef');
    this.contaRefService.consultar().subscribe(
      contaRef => {
        this.contaRef = contaRef;

        if(contaRef.codigoBanco == null) {
              this.contaRef = new ContaRef();
        }

        this.contaRef.codigoBanco = "341";
        this.nomeBanco = 'ITAÚ UNIBANCO S.A.';

        this.carregandoService.esconde('buscarContaRef');
      },
      err => {
        this.carregandoService.esconde('buscarContaRef');
        this.notificacaoService.erro(err);
      }
    )
  }

  salvar() {
    this.carregandoService.mostra('salvar');

    this.contaRef.pMulta = Number(this.contaRef.pMulta);
    this.contaRef.pJuro = Number(this.contaRef.pJuro);

    this.contaRefService.salvar(this.contaRef).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.sucesso('Configuração de boleto salva com sucesso!!!');
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    )
  }

  fechar() {
    this.dialogRef.close();
  }

}
